import { ImagePaths } from '../../lib/imageUrls.js';

export const complianceGovernance = {

    id: 4,
    slug: 'compliance-governance',
    ogImage: '/og/courses/compliance-governance.jpg',
    courseCode: 'COMPLY-GOV-001',
    title: 'Compliance & Governance',
    subtitle: 'Navigate regulatory requirements with confidence',
    duration: '35 hours',
    students: 'New',
    level: 'Intermediate',
    image: ImagePaths.COURSE_4,
    shortDescription: 'COMPLY-GOV-001 — cybersecurity compliance and governance covering ISO 27001, NIST CSF and risk management for compliance and risk officers.',
    price: {
      aud: 1499,
      currency: 'AUD',
      earlyBird: 1199
    },
    stripeConfig: {
    priceId: 'price_1SdKRKKu1nyc322UoWsQOMuJ',
    productId: 'prod_TaVSCItbrh5PqV'
  },
    
    overview: 'Master the complex world of cybersecurity compliance and governance. Learn to implement and manage compliance programs across multiple frameworks while balancing business needs with regulatory requirements.',
    
    outcomes: [
      'Implement compliance programs for major frameworks',
      'Conduct compliance assessments and gap analysis',
      'Develop security policies and procedures',
      'Manage risk assessment and treatment',
      'Prepare for regulatory audits',
      'Build governance structures and oversight programs'
    ],
    
    audience: [
      'Compliance officers and risk managers',
      'Security managers building compliance programs',
      'Auditors and consultants',
      'IT managers responsible for compliance',
      'Privacy officers and data protection specialists'
    ],
    
    prerequisites: [
      'Understanding of information security basics',
      'Familiarity with business operations',
      'No specific technical requirements'
    ],
    
    modules: [
      {
        title: 'Governance Frameworks',
        duration: '8 hours',
        topics: [
          'ISO 27001/27002 standards',
          'NIST Cybersecurity Framework',
          'CIS Controls',
          'Building governance programs'
        ]
      },
      {
        title: 'Risk Management',
        duration: '7 hours',
        topics: [
          'Risk assessment methodologies',
          'Risk treatment and mitigation',
          'Business impact analysis',
          'Risk reporting and communication'
        ]
      },
      {
        title: 'Privacy and Data Protection',
        duration: '8 hours',
        topics: [
          'GDPR compliance requirements',
          'Australian Privacy Principles (APPs)',
          'Data classification and handling',
          'Privacy impact assessments'
        ]
      },
      {
        title: 'Industry Compliance',
        duration: '7 hours',
        topics: [
          'PCI DSS for payment systems',
          'HIPAA for healthcare',
          'SOC 2 reporting',
          'Industry-specific requirements'
        ]
      },
      {
        title: 'Audit and Assessment',
        duration: '5 hours',
        topics: [
          'Internal audit programs',
          'Third-party assessments',
          'Evidence collection and documentation',
          'Continuous compliance monitoring'
        ]
      }
    ],
    
    format: {
      type: 'Self-paced with expert mentorship',
      includes: [
        '35 hours of compliance training',
        'Policy templates and frameworks',
        'Compliance assessment tools',
        'Monthly mentor sessions',
        'Certificate of completion',
        '12 months access'
      ]
    },
    
    nextIntake: {
      date: 'Register your interest — we will confirm the next cohort',
      details: 'Begin immediately with instant access'
    },
    
    faqs: [
      {
        question: 'Is this course technical?',
        answer: 'This course focuses on compliance frameworks, policies, and processes. Technical knowledge is helpful but not required.'
      },
      {
        question: 'Which frameworks are covered?',
        answer: 'We cover ISO 27001, NIST CSF, CIS Controls, GDPR, PCI DSS, SOC 2, and Australian compliance requirements.'
      },
      {
        question: 'Will I learn to conduct audits?',
        answer: 'Yes, you\'ll learn audit planning, execution, and reporting for both internal and third-party assessments.'
      }
    ]
};
